import { defaultBranding, getBrandingByHostname } from '@/configs/brandingConfig'

export const branding = {
  namespaced: true,

  state: {
    branding: defaultBranding,
    isLightMode: defaultBranding.isLightMode
  },

  getters: {
    branding: (state) => state.branding,
    isLightMode: (state) => state.isLightMode,
    logoPath: (state) => state.branding.logoPath,
    primaryColor: (state) => state.branding.primaryColor,
    brandName: (state) => state.branding.name
  },

  mutations: {
    SET_BRANDING(state, branding) {
      state.branding = branding
    },

    SET_LIGHT_MODE(state, isLightMode) {
      state.isLightMode = isLightMode
    }
  },

  actions: {
    initBranding({ commit }, hostname) {
      const branding = getBrandingByHostname(hostname)
      commit('SET_BRANDING', branding)
      commit('SET_LIGHT_MODE', branding.isLightMode)
    }
  }
}
